import { Translatable } from "@icc/shared/helpers";

export class RollerRemoteControl {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    img: string;
    description: string;
    shortDescription: string;
    /** Przypisane typy sterowania */
    rollerShutterDrivesIds?: number[];
    amount?: number;
    /** Kolejność */
    order: number;
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
    type: 'remote_control' | 'receiver';
    /** Przypisane zależności napędów (wykluczenia skrzynek, wyjść sterowania) */
    driveDependencyIds?: number[];

    driveId?: number;
    /** Czy akcesorium jest wymagane przez wybrany wariant napędu */
    isRequired?: boolean;
    /** Czy akcesorium zostało automatycznie dodane przez system */
    autoAdded?: boolean;
}
